import { createSelector } from 'reselect';

export const getPrioritiesAccesor = state => state.tickets.priorities;

export const prioritiesSelector = createSelector(getPrioritiesAccesor, priorities => priorities);
